import { Button, type ButtonProps } from 'antd';
import type { MouseEvent } from 'react';
import { PrintHint } from './components/PrintHint.tsx';
import { useCanPrint } from './hooks/usePrinter.ts';
import { useSingleFlight } from './hooks/useSingleFlight.ts';

type Props = Omit<ButtonProps, 'onClick'> & { onClick?: (event: MouseEvent<HTMLElement>) => unknown };

/**
 * A button that prints: disabled, with the reason, where this tab has no print path. While the print its click started
 * runs, it is busy and takes no second click, since over the AIS that takes seconds.
 */
export const PrintButton = ({ disabled, loading, onClick, ...props }: Props) => {
  const canPrint = useCanPrint();
  const [click, idle] = useSingleFlight(async (event: MouseEvent<HTMLElement>) => {
    await onClick?.(event);
  }, true);
  return (
    <PrintHint canPrint={canPrint}>
      <Button {...props} loading={loading || !idle} disabled={!canPrint || disabled} onClick={click} />
    </PrintHint>
  );
};
